import { render, staticRenderFns } from "./AuditoriaAfDetalleComponent.vue?vue&type=template&id=59c8836e&scoped=true&"
import script from "./AuditoriaAfDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./AuditoriaAfDetalleComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuditoriaAfDetalleComponent.vue?vue&type=style&index=0&id=59c8836e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8836e",
  null
  
)

export default component.exports